<template>
  <Toast />
  <Panel header="Instances" class="p-mt-3">
    <h6>TBD</h6>
  </Panel>
  
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'Instances',
  components: {
  },
  data () {
    return {
      errors: {},
      loading: false,
      domain: {id: null, name: "", services: [], attributes: []},
      loading: false,
    }
  },
  computed: {
  },
  watch: {
  },
  methods: {

  }
}
</script>

<style scoped>

</style>
